/* eslint no-multi-spaces: 0 */
/* eslint key-spacing    : 0 */

const chartColors = {
  purple:       '#51226c',
  purpleLight1: '#61407a',
  purpleLight2: '#a686c9',
  blue:         '#009FCC',
  blueLight:    '#60b8d1',
  blueLight1:   '#8cc9da',
  blueLight2:   '#cde2e8',
  green:        '#a9d85f',
  greenLight1:  '#bee187',
  greenLight2:  '#d4ebaf',
  red:          '#E02630',
  redLight:     '#ffcacc',
  orange :      '#ffba15',
  organgeLight: '#ffdf94',
  grey:         '#b3b3b3',
  greyDark:     '#4d4d4d',
  greyLight:    '#CCCCCC',
  yellowish:    '#ffba15'
}

export default chartColors



// WEBPACK FOOTER //
// ./src/core/charts/helper/chartColors.js